export default __webpack_public_path__ + "static/media/restaurant.b6be29fe.svg";